// nullary conditions types
export enum Condition0Type {}
// unary conditions types
export enum Condition1Type {
  textStartsWith = "textStartsWith",
}
// binary conditions types
export enum Condition2Type {}
